
import { Component, Mixins } from "vue-property-decorator";
import { formMixin, formOptionsMixin, formValidationMixin } from "../mixins";

@Component
export default class ReferenceTypeEditor extends Mixins(
  formMixin,
  formOptionsMixin,
  formValidationMixin
) {
  referenceType: string = null;
  referenceNumber: string = null;
  showAddReferenceNumber: boolean = false;

  addReferenceNumber() {
    this.localValue.push({
      type: this.referenceType,
      number: this.referenceNumber,
      id: `${this.referenceType}_${this.referenceNumber}`
    });
    this.referenceType = null;
    this.referenceNumber = null;
  }

  removeItem(item) {
    const index = this.localValue.map(x => x.id).indexOf(item.id);
    if (index < 0) {
      return;
    }
    this.localValue.splice(index, 1);
  }
}
